import { useGetQuizsetTitle } from '@/api';

export const useQuizsetTitle = (id: string) => {
  const { data } = useGetQuizsetTitle({ quizsetId: id });
  return data?.data ?? '';
};
